var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 239,
    viewBox: "0 0 195 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_784_72784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 45.1327C34.5655 45.6219 57.2179 37.2558 55.3036 -0.122681C56.7393 15.6963 57.4571 45.1327 90 47.3343C65.1143 47.3343 55.3036 54.2816 55.3036 90.8773C55.2238 75.6291 48.6514 45.1327 23 45.1327Z",
    stroke: "url(#paint0_linear_784_72784)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 89.7268C127.905 90.0117 141.429 85.1392 140.286 63.3693C141.143 72.5825 141.571 89.7268 161 91.009C146.143 91.009 140.286 95.0553 140.286 116.369C140.238 107.488 136.314 89.7268 121 89.7268Z",
    stroke: "url(#paint1_linear_784_72784)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_784_72784",
    x1: 82.0449,
    y1: 45.3773,
    x2: 23,
    y2: 45.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FFE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_784_72784",
    x1: 156.251,
    y1: 89.8692,
    x2: 121,
    y2: 89.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FFE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFF4A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_784_72784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 238,
    fill: "white",
    transform: "translate(0 0.369263)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.63bae6a11e45f98f9171746bad4623d9.svg";
export { ForwardRef as ReactComponent };